module.exports = __webpack_public_path__ + "olivier-ac4f0233b7c7e43f4e6d7f2f58d9109d.webp";